<template>
  <Page v-bind="page" @success="$emit('success',$event)" @formLoaded="formLoaded"> 
  </Page>
</template>

<script>
import Page from "@/components/Page/BasisFormPage.vue";
export default {
  props: {
    success: Function,
    close: Function,
    pars: Object
  },
  components: {
    Page
  },
  data() {
    return {
      page: {
        moduleInfo: {
          area: "Business",
          name: "UserComment",
          direction: "用户留言"
        },
        pageInfo: {
          success: this.success,
          close: this.close,
          pars: this.pars
        }
      },
      Replys: []
    };
  },
  methods: {
    formLoaded({ Replys }) {
      this.Replys = Replys;
    }
  }
};
</script>

<style>
</style>
